import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { MeResponse } from '~shared/models/me-response.model';
import { BaseApiService } from '../base.api-service';

@Injectable({ providedIn: 'root' })
export class MeApiService extends BaseApiService {
  getMe(): Observable<MeResponse> {
    return this.http.get<MeResponse>(environment.apiBasePaths.data + '/me');
  }
}
